import React, { useEffect } from "react";
import { Col, Form, Row, Input } from "antd";
import BannerCard from "../../../common/components/BannerCard";

const CasePaymentsName = ({ ...props }) => {
  const { form, caseMaster } = props;

  useEffect(() => {
    const paymentData = caseMaster?.payments?.MAIN[0];
    form.setFieldsValue({ ...paymentData });
  }, [caseMaster?.payments?.MAIN, form]);

  return (
    <BannerCard title="Person Details">
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col lg={24} md={24} sm={24} xs={24}>
            <Form.Item name="NAME" label="Name">
              <Input readOnly />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </BannerCard>
  );
};

export default CasePaymentsName;
